import {InjectionToken} from "@angular/core";

export const PAGE_DATA = new InjectionToken<any>('PAGE_DATA');
export const ROUTE_DATA = new InjectionToken<any>('ROUTE_DATA');
